export enum ImgID
{
  None,

  // MenuScreen
  IconCoin,
  IconHeart,
  IconPlus,
  UI_MenuCircus,
  UI_MenuPlaza,
  UI_MenuMountains,
  UI_MenuCloud,
  UI_PlayButton,
  UI_MenuBlockBg,
  UI_MenuSettingsIcon,
  UI_MenuRemoveAdsIcon,
  UI_RemoveAdsIcon,
  UI_NoAdsTimer,
  UI_Car,
  UI_CarWheelCircle,
  UI_CarHard,
  UI_CarSuperHard,
  UI_CarBalls,
  UI_CarCannon,
  UI_CarCannonWheel,
  UI_CarCannonWheelCircle,
  UI_CarCannonWheelBase,
  UI_CarRoof,
  UI_CarRoofBase,
  UI_TigerHead,
  UI_TigerEyes,
  UI_TigerBody,
  UI_AdventureWidget,
  IconMenuMsg,
  UI_DailyChallengeWidget,

  // GameScreen
  IconSettings,
  IconSettingsPurple,
  IconSettingsRed,
  UI_GameBlockBg,
  UI_GameBlockBgPurple,
  UI_GameBlockBgRed,
  UI_GameLevelTape,
  UI_GameLevelTapePurple,
  UI_GameLevelTapeRed,
  UI_GameSoundOn,
  UI_GameSoundOff,
  UI_GameMusicOn,
  UI_GameMusicOff,
  UI_GameVibrationOn,
  UI_GameVibrationOff,
  UI_GameExit,
  UI_GameBoosterLockedTape,
  UI_GameBoosterBottom,
  UI_GameBoosterProgressBase,
  UI_GameBoosterProgressFill,
  UI_GameDailyChallengeHeader,

  // AdventureScreen
  UI_AdventureBg,
  UI_AdventureZeroFloor,
  UI_AdventureHouseCentre,
  UI_AdventureHouseTop,
  UI_AdventureButton,
  UI_AdventureCoil,
  UI_AdventureFloorBg,
  IconAdventureCompleted,
  UI_AdventureTowerCenterFill,
  UI_AdventureTowerTopFill,
  UI_AdventureProgressBg,
  UI_AdventureTiger,
  UI_AdventureCoilLine,
  UI_AdventureBoxMain,
  UI_AdventureBoxOpen,
  UI_AdventureBoxClose,
  UI_AdventureTigerHead,
  UI_AdventureBalloonPurple,
  UI_AdventureBalloonRed,
  UI_AdventureBalloonYellow,
  UI_AdventureBalloonBlue,
  UI_CoinBg,
  UI_AdventureHeaderBg,
  UI_AdventureHeaderBottom,
  UI_AdventureHeaderTimer,
  UI_AdventureProgressCircle,
  UI_AdventureProgressCircleFirst,

  // DailyChallengeScreen
  UI_DailyChallengeBg,
  UI_DailyChallengeTimerBg,
  UI_DailyChallengeContentBorder,
  UI_DailyChallengeContentBg,
  UI_DailyChallengeCurrentLvl,
  UI_DailyChallengeNextLvl,
  UI_DailyChallengeCompletedLvl,
  UI_DailyChallengeRightArrow,
  UI_DailyChallengeLeftArrow,
  UI_DailyChallengeTopArrow,
  IconDailyChallengeCompleted,
  IconDailyChallengeLocked,
  UI_DailyChallengePlayButton,

  // TryAgainChallengeDialog
  UI_TryAgainChallengeTopImage,
  UI_TryAgainChallengeLevelBg,

  // DailyChallengeInfoOverlay
  UI_DailyChallengeInfoTopImage,
  UI_DailyChallengeInfoCenterImage,
  UI_DailyChallengeInfoBottomImage,

  // ChainOfferScreen
  UI_ChainOfferIcon,
  UI_ChainOfferBalloonIcon,
  UI_ChainOfferConfetti,
  UI_ChainOfferSnakeChain,
  UI_ChainOfferSubstrate,
  UI_ChainOfferSubstrateActive,
  UI_ChainOfferGreenBtn,
  UI_ChainOfferLockIcon,
  UI_ChainOfferVideoIcon,
  UI_ChainOfferCloud,
  UI_ChainOfferTimerSubstrate,

  // ChainVideoScreen
  UI_ChainVideoIcon,
  UI_ChainVideoTimerBg,
  UI_ChainVideoTopCat,

  // AdventureInfoOverlay
  UI_AdventureInfoTopPart,
  UI_AdventureInfoBottomPart,
  UI_AdventureInfoCenterPart,
  IconOverlayClose,
  UI_AdventureEndedTopPart,
  UI_DailyTasksEndedTopPart,

  // TutorialScreen
  IconTutorialCursor,
  UI_TutorialSubstrate,

  // NavigationBlock
  IconNavigationMenu,
  IconNavigationShop,
  IconNavigationSettings,
  IconNavigationLeaderboard,
  UI_NavigationMainBg,
  UI_NavigationIconBg,
  UI_NavigationBg,

  // ShopScreen
  UI_ShopTileBg,
  UI_ShopTopBg,
  UI_ShopCoinOfferBg,
  UI_ShopBlockImg,
  UI_ShopTopImg,
  UI_ShopBtn,

  // SettingsScreen
  UI_SettingsSupportBtn,
  UI_SettingsLinkBtn,
  UI_SettingsToggleTrack,
  UI_SettingsSoundIcon,
  UI_SettingsMusicIcon,
  UI_SettingsVibrationIcon,

  // SettingsDialog
  UI_SettingsDialogDivider,
  UI_SettingsDialogCloseBtn,
  UI_SettingsDialogCopyBtn,
  UI_VibrationsProgressBar,
  UI_SettingsGraphicsIcon,
  UI_SettingsGraphicsTrack,

  // DeleteAccountDialog
  IconWarningYellow,
  UI_ConfirmSubstrate,
  UI_ConfirmMark,

  // LoadingScreen
  UI_LoadingBg,
  UI_LoadingProgressBarBase,
  UI_LoadingProgressBarFill,
  UI_LoadingLogoRoyal,
  UI_LoadingLogoSmash,
  UI_LoadingLogoCrown,
  UI_LoadingLogoCrowl,
  UI_LoadingLogoSubstrate,
  UI_LoadingCannonWithBarrel,

  // Result goal
  UI_ResultGoalBg,
  UI_ResultProgressBarBg,
  UI_ResultProgressBarFill,
  UI_ResultProgressBarFillAvailable,
  UI_ResultStarBoxGoal,

  UI_GoalIceCube,
  UI_GoalCherryJar,
  UI_GoalBlueBox,
  UI_GoalStoneBox,
  UI_GoalBrickBox,
  UI_GoalWatermelonBlock,
  UI_GoalWoodLog,
  UI_GoalCrownBoxGreen,
  UI_GoalCrownBoxPurple,
  UI_GoalPlasticBoxBlue,
  UI_GoalPlasticBoxGreen,
  UI_GoalPlasticBoxLightBlue,
  UI_GoalPlasticBoxOrange,
  UI_GoalPlasticBoxPink,
  UI_GoalPlasticBoxPurple,
  UI_GoalPlasticBoxRed,
  UI_GoalPlasticBoxYellow,
  UI_GoalColumnBox,
  UI_GoalFanBarrier,
  UI_GoalHammerBarrier,
  UI_GoalRotatingTable,
  UI_GoalRightLeftTable,
  UI_GoalTopBottomTable,
  UI_GoalTiltingTable,

  // Common
  UI_CapsuleBlueRed,
  UI_CapsuleBluePurple,
  UI_CapsuleBlue,
  UI_DialogSlotFrame,
  UI_PaternedBg,
  UI_DiamondTile,
  UI_GreenFrameBtn,
  UI_RedBtn,
  UI_PurpleFrameBtn,
  UI_NonActiveBtn,
  UI_Fireworks,
  UI_FireworksThree,
  UI_TopBanner,
  UI_GoldenRibbon,
  UI_TigerIcon,
  UI_CrushedHeart,
  UI_Hearts,
  UI_CounterBg,
  UI_ClockFrame,
  UI_ClockHand,
  UI_VideoIcon,
  UI_PlayDialogTop,
  UI_GameStartBoosterBg,
  UI_GameStartFireworkBooster,
  UI_GameStartMultiballsBooster,
  UI_GameStartBigBallBooster,
  UI_GameStartInfiniteBallsBooster,
  UI_GameStartLockedBooster,
  UI_GameStartContentBg,
  UI_PlayDialogBgHalfCommon,
  UI_PlayDialogBgHalfHard,
  UI_PlayDialogBgHalfSuperHard,
  UI_GameStartBoosterTitle,
  UI_GameStartRedCircle,
  UI_GameStartRibbonHard,
  UI_GameStartRibbonSuperHard,
  UI_PlusBtn,
  UI_TooltipArrow,
  UI_RocketBooster,
  IconDailyChallenge,
  UI_DailyChallengeTimer,

  // ConnectionFailedDialog
  UI_ConnectionFailedIcon,

  // BoosterDialog
  UI_BoosterNameBg,
  UI_BoosterDialogFrameBg,
  UI_PassiveBoosterDisabled,
  UI_PassiveBoosterEnabled,
  UI_PassiveBoosterSelectedBadge,
  UI_PassiveBoosterCountBadge,
  UI_PassiveBoosterPlusBadge,
  UI_PassiveBoosterRocket,
  UI_PassiveBoosterBomb,

  // ProfileDialog
  AvatarCircle,
  UI_AvatarSelectInactiveBtn,
  UI_AvatarSelectActiveBtn,
  IconEdit,
  IconCopy,
  ProfileStarIcon,

  //AccountDialogs
  AppleIcon,
  GoogleIcon,
  PlusIconWhite,

  // Leaderboard
  IconLeaderboard,
  FacebookIcon,
  IconAvatarSelected,
  UI_LeaderboardArrowButton,
  UI_LeaderboardStarBlue,
  UI_LeaderboardStarBrown,
  UI_LeaderboardStarOrange,
  UI_LeaderboardSelectedSideTab,
  UI_LeaderboardSelectedMiddleTab,
  UI_LeaderboardUnselectedSideTab,
  UI_LeaderboardUnselectedMiddleTab,
  UI_LeaderboardSubstratePlayerNew,
  UI_LeaderboardSubstrateYouNew,
  UI_LeaderboardStatsComponent,
  UI_LeaderboardTopTabSubstrate,
  UI_LeaderboardTopBg,
  UI_LeaderboardPlayerAvatarSub,
  UI_LeaderboardCrown,
  UI_LeaderboardPointIcon,
  UI_LeaderboardEye,
  UI_LeaderboardInfoButton,
  UI_LeaderboardInfoTopPart,
  UI_LeaderboardInfoCenterPart,
  UI_LeaderboardInfoBottomPart,
  UI_LeaderboardInfoArrow,
  UI_LeaderboardSpinner,
  UI_LeaderboardSoonBadge,
  UI_LeaderboardContentPanel,
  UI_LeaderboardSubstrateYellow,
  UI_LeaderboardSubstrateAqua,
  UI_LeaderboardSubstrateOrange,
  UI_LeaderboardSubstrateBlue,
  UI_LeaderboardSubstratePurple,
  UI_LeaderboardSubstrateViolet,

  // Daily tasks tutorial overlay
  UI_DailyTasksTop,
  UI_DailyTasksCenter,
  UI_DailyTasksBottom,
  UI_DailyTasksArrow,
  UI_DailyTasksCloseBtn,
  UI_DailyTasksTowerShortcut,
  UI_DailyTasksShortcut,

  // Daily tasks screen
  UI_DailyTasksScreenTopBg,
  UI_DailyTasksScreenTitleBg,
  UI_DailyTasksScreenTimerBg,
  UI_DailyTasksScreenContentBg,
  UI_DailyTasksScreenInfo,
  UI_DailyTasksTasksBg,
  UI_DailyTasksProgressBase,
  UI_DailyTasksProgressFill,
  UI_DailyTasksProgressStar,
  UI_DailyTasksProgressConfirm,
  UI_DailyTasksRewardChest,
  UI_DailyTasksCurrentDayBg,
  UI_DailyTasksCurrentDaySelected,
  UI_DailyTasksNotSelectedDayBg,
  UI_DailyTasksNotSelectedDayMain,
  UI_DailyTasksTaskNormal,
  UI_DailyTasksTaskClaim,
  UI_DailyTasksTaskComplete,
  UI_DailyTasksTaskProgressBar,
  UI_DailyTasksTaskCoins,
  UI_DailyTasksTaskCannon,
  UI_DailyTaskMetricLoginDays,
  UI_DailyTaskMetricLevels,
  UI_DailyTaskMetricLevelsHard,
  UI_DailyTaskMetricLevelsSuperHard,
  UI_DailyTaskMetricTowerFloors,
  UI_DailyTaskMetricLevelStreak,
  UI_DailyTaskMetricStars,
  UI_DailyTaskMetricCoins,
  UI_DailyTaskMetricBoosters,
  UI_DailyTaskMetricAttempts,
  UI_DailyTaskMetricAds,
  UI_DailyTaskMetricPurchases,
  UI_DailyTaskMetricBlocks,
  UI_DailyTaskMetricBoss,
  UI_DailyTaskMetricBossStages,
  UI_DailyTasksDayLock,
  UI_DailyTasksDayBadge,
  UI_DailyTaskBoxMain,
  UI_DailyTaskBoxOpen,
  UI_DailyTaskBoxClose,

  // GameResultOverlay
  UI_ResultBannerCommon,
  UI_ResultBannerHard,
  UI_ResultBannerSuperHard,
  UI_ResultStar,
  UI_ResultRewardBg,
  UI_GameAdventureProgressBg,
  UI_GameAdventureProgressFill,

  // Avatars
  Avatar_0,
  Avatar_1,
  Avatar_2,
  Avatar_3,
  Avatar_4,
  Avatar_5,
  Avatar_6,
  Avatar_7,
  Avatar_8,
  Avatar_9,
  Avatar_10,
  Avatar_11,
  Avatar_12,
  Avatar_13,
  Avatar_14,
  Avatar_15,
  Avatar_16,
  Avatar_17,
  Avatar_18,
  Avatar_19,

  // Country flags
  Flag_unknown,
  Flag_unknown_v2,
  Flag_AD,
  Flag_AE,
  Flag_AF,
  Flag_AG,
  Flag_AI,
  Flag_AL,
  Flag_AM,
  Flag_AN,
  Flag_AO,
  Flag_AQ,
  Flag_AR,
  Flag_AS,
  Flag_AT,
  Flag_AU,
  Flag_AW,
  Flag_AX,
  Flag_AZ,
  Flag_BA,
  Flag_BB,
  Flag_BD,
  Flag_BE,
  Flag_BF,
  Flag_BG,
  Flag_BH,
  Flag_BI,
  Flag_BJ,
  Flag_BL,
  Flag_BM,
  Flag_BN,
  Flag_BO,
  Flag_BR,
  Flag_BS,
  Flag_BT,
  Flag_BW,
  Flag_BY,
  Flag_BZ,
  Flag_CA,
  Flag_CC,
  Flag_CD,
  Flag_CF,
  Flag_CG,
  Flag_CH,
  Flag_CI,
  Flag_CK,
  Flag_CL,
  Flag_CM,
  Flag_CN,
  Flag_CO,
  Flag_CR,
  Flag_CU,
  Flag_CV,
  Flag_CW,
  Flag_CX,
  Flag_CY,
  Flag_CZ,
  Flag_DE,
  Flag_DJ,
  Flag_DK,
  Flag_DM,
  Flag_DO,
  Flag_DZ,
  Flag_EC,
  Flag_EE,
  Flag_EG,
  Flag_EH,
  Flag_ER,
  Flag_ES,
  Flag_ET,
  Flag_EU,
  Flag_FI,
  Flag_FJ,
  Flag_FK,
  Flag_FM,
  Flag_FO,
  Flag_FR,
  Flag_GA,
  Flag_GB,
  Flag_GD,
  Flag_GE,
  Flag_GG,
  Flag_GH,
  Flag_GI,
  Flag_GL,
  Flag_GM,
  Flag_GN,
  Flag_GQ,
  Flag_GR,
  Flag_GS,
  Flag_GT,
  Flag_GU,
  Flag_GW,
  Flag_GY,
  Flag_HK,
  Flag_HN,
  Flag_HR,
  Flag_HT,
  Flag_HU,
  Flag_IC,
  Flag_ID,
  Flag_IE,
  Flag_IL,
  Flag_IM,
  Flag_IN,
  Flag_IQ,
  Flag_IR,
  Flag_IS,
  Flag_IT,
  Flag_JE,
  Flag_JM,
  Flag_JO,
  Flag_JP,
  Flag_KE,
  Flag_KG,
  Flag_KH,
  Flag_KI,
  Flag_KM,
  Flag_KN,
  Flag_KP,
  Flag_KR,
  Flag_KW,
  Flag_KY,
  Flag_KZ,
  Flag_LA,
  Flag_LB,
  Flag_LC,
  Flag_LI,
  Flag_LK,
  Flag_LR,
  Flag_LS,
  Flag_LT,
  Flag_LU,
  Flag_LV,
  Flag_LY,
  Flag_MA,
  Flag_MC,
  Flag_MD,
  Flag_ME,
  Flag_MF,
  Flag_MG,
  Flag_MH,
  Flag_MK,
  Flag_ML,
  Flag_MM,
  Flag_MN,
  Flag_MO,
  Flag_MP,
  Flag_MQ,
  Flag_MR,
  Flag_MS,
  Flag_MT,
  Flag_MU,
  Flag_MV,
  Flag_MW,
  Flag_MX,
  Flag_MY,
  Flag_MZ,
  Flag_NA,
  Flag_NC,
  Flag_NE,
  Flag_NF,
  Flag_NG,
  Flag_NI,
  Flag_NL,
  Flag_NO,
  Flag_NP,
  Flag_NR,
  Flag_NU,
  Flag_NZ,
  Flag_OM,
  Flag_PA,
  Flag_PE,
  Flag_PF,
  Flag_PG,
  Flag_PH,
  Flag_PK,
  Flag_PL,
  Flag_PN,
  Flag_PR,
  Flag_PS,
  Flag_PT,
  Flag_PW,
  Flag_PY,
  Flag_QA,
  Flag_RO,
  Flag_RS,
  Flag_RU,
  Flag_RW,
  Flag_SA,
  Flag_SB,
  Flag_SC,
  Flag_SD,
  Flag_SE,
  Flag_SG,
  Flag_SH,
  Flag_SI,
  Flag_SK,
  Flag_SL,
  Flag_SM,
  Flag_SN,
  Flag_SO,
  Flag_SR,
  Flag_SS,
  Flag_ST,
  Flag_SV,
  Flag_SY,
  Flag_SZ,
  Flag_TC,
  Flag_TD,
  Flag_TF,
  Flag_TG,
  Flag_TH,
  Flag_TJ,
  Flag_TK,
  Flag_TL,
  Flag_TM,
  Flag_TN,
  Flag_TO,
  Flag_TR,
  Flag_TT,
  Flag_TV,
  Flag_TW,
  Flag_TZ,
  Flag_UA,
  Flag_UG,
  Flag_US,
  Flag_UY,
  Flag_UZ,
  Flag_VA,
  Flag_VC,
  Flag_VE,
  Flag_VG,
  Flag_VI,
  Flag_VN,
  Flag_VU,
  Flag_WF,
  Flag_WS,
  Flag_YE,
  Flag_YT,
  Flag_ZA,
  Flag_ZM,
  Flag_ZW,
  Flag_abkhazia,
  Flag_basque_country,
  Flag_british_antarctic_territory,
  Flag_commonwealth,
  Flag_england,
  Flag_gosquared,
  Flag_kosovo,
  Flag_mars,
  Flag_nagorno_karabakh,
  Flag_nato,
  Flag_northern_cyprus,
  Flag_olympics,
  Flag_red_cross,
  Flag_scotland,
  Flag_somaliland,
  Flag_south_ossetia,
  Flag_united_nations,
  Flag_wales,

  UI_RateDialogStar,
  UI_RateDialogStarFilled,
  UI_RateDialogGameIconFrame,
  UI_RateDialogGameIcon,
  UI_RateDialogBlueButton,
  UI_RateGameIcon,
  IconUpdateRequired,
  UI_MenuGreenButton,
  UI_MenuButtonBlue,

  // NoLevelsDialog
  UI_NoLevelsTiger,
  UI_NoLevelsRibbon,
  UI_NoLevelsTape,
  UI_NoLevelsGradient,

  // Append new IDs here so existing numeric image keys stay stable.
  UI_ShopTabsBg,
  UI_ShopTabActive,
  UI_ShopTabInactive,
  UI_ShopBottomBg,
  UI_ShopBundleBg,
  UI_ShopBundleCoinsSmall,
  UI_ShopBundleCoinsSmallSet,
  UI_ShopBundleCoinsAverage,
  UI_ShopBundleCoinsLarge,
  UI_ShopBestBadge,
  UI_ShopNoAdsBundleBg,
  UI_ShopDiscountBg,
  UI_ShopLowerPrice,
  UI_ShopInfiniteHeart,
  UI_ShopTimerBg,
  UI_TowerFailDarkBlueSubstrate,
  UI_ContinueOfferTitleBadge,
  UI_TowerFailGreenBtnHalf,
  UI_OnePlusOneOfferIcon,
  UI_OnePlusOneOfferSky,
  UI_OnePlusOneOfferFrame,
  UI_OnePlusOneOfferTiger,
  UI_OnePlusOneOfferConfetti,
  UI_OnePlusOneOfferPlus,
  UI_OnePlusOneOfferGreenBtn,
  UI_OnePlusOneOfferTimerBg,
  UI_OnePlusOneOfferLock,
  UI_OnePlusOneOfferCoins,
  UI_OnePlusOneOfferInfiniteHeart,
  UI_OnePlusTwoOfferIcon,
  UI_OnePlusTwoOfferSky,
  UI_OnePlusTwoOfferTiger,
  UI_MysteryBoxOfferIcon,
  UI_MysteryBoxTitle,
  UI_MysteryBoxTiger,
  UI_MysteryBoxTooltipEdge,
  UI_MysteryBoxChestBottom,
  UI_MysteryBoxChestClosedTop,
  UI_MysteryBoxChestOpenedTop,
  UI_MysteryBoxInfoBtn,

  UI_StartOfferBg,
  UI_StartOfferMainImg,
  UI_StartOfferIcon,
  UI_CapsuleTopBgPart,
  UI_WarningIcon,
  UI_MenuTournamentBtn,
  UI_TournamentBgBlue,
  UI_TournamentBgPart,
  UI_TournamentTopSubstrate,
  UI_TournamentInfoBtn,
  UI_TournamentSubstrateMain,
  UI_TournamentBlueCapsule,
  UI_TournamentProgressBg,
  UI_TournamentProgressFill,
  UI_TournamentCrownBg,
  UI_TournamentCrownIcon,
  UI_TournamentGingerCapsule,
  UI_TournamentBoxPurple,
  UI_TournamentTopOrangeSubstrate,
  UI_TournamentItemBg,
  UI_TournamentItemTopBg,
  UI_TournamentItemPlayerBg,
  UI_TournamentBoxGreen,
  UI_TournamentBoxBlue,
  UI_TournamentBoxRed,
  UI_TournamentCrownsSubstrate,
  UI_TournamentCrownsSubstratePlayer,
  UI_TournamentCheck,
  UI_TournamentMiniCrown,
  UI_TournamentBoxWhite,
  UI_TournamentBoxWhiteOpen,
  UI_TournamentBoxGreenOpen,
  UI_TournamentBoxBlueOpen,
  UI_TournamentBoxRedOpen,
  UI_TournamentBoxPurpleOpen,
  UI_TournamentResultBanner,
  UI_TournamentStarFirst,
  UI_TournamentStarSecond,
  UI_TournamentStarThird,
  UI_TournamentMiniPbBg,
  UI_TournamentMiniPbBase,

  // VFX ================================================================================================================
  
  CoinAtlas,
  ConfettiAtlas,
    
  // Glows
  CircleGlow1,
  CircleGlow2,
  CircleGlow3,
  CircleGlow4,
  CircleGlow5,
  SparkGlow2,
  SparkGlow3,
  RaysGlow1,
  LineGlow1,

  // Key Hunt
  UI_KeyHuntLobbyIcon,
  UI_KeyHuntBanner,
  UI_KeyHuntKeybarPanel,
  UI_KeyHuntKeybarSocket,
  UI_KeyHuntPlus,
  UI_KeyHuntKeybarTrack,
  UI_KeyHuntKeybarFill,
  UI_KeyHuntKeyBig,
  UI_KeyHuntPrizeCard,
  UI_KeyHuntChooseBtn,
  UI_KeyHuntSafeClosed,
  UI_KeyHuntSafeOpen,
  UI_KeyHuntInfoTasks,
  UI_KeyHuntInfoPrize,
  UI_KeyHuntInfoSafe,
  UI_PrizeShotLobbyIcon,
  UI_PrizeShotLogo,
  UI_PrizeShotLoadingArt,
  UI_PrizeShotTimerBg,
  UI_PrizeShotTigerPlank,
}
